/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/award': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.8 8a6.2 6.2 0 119.631 5.165.796.796 0 00-.144.093A6.2 6.2 0 015.8 8zm9.35 7.138A7.774 7.774 0 0112 15.8a7.773 7.773 0 01-3.149-.662l-.84 6.322 3.578-2.146a.8.8 0 01.823 0l3.577 2.146-.839-6.322zm-7.797-.873a7.8 7.8 0 119.295 0l1.145 8.63a.8.8 0 01-1.204.791L12 20.933l-4.588 2.753a.8.8 0 01-1.205-.791l1.146-8.63z" _fill="currentColor"/><path pid="1" d="M12 15a7 7 0 100-14 7 7 0 000 14z" _stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="2" d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12" _stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
